import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-undo",
  "use": "icon-undo-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-undo\"><path d=\"M512 325.888A186.368 186.368 0 1 0 698.112 512 186.112 186.112 0 0 0 512 325.888zm416 139.776A418.304 418.304 0 0 0 558.592 96V0h-93.184v96A418.304 418.304 0 0 0 96 465.664H0v92.928h96a418.56 418.56 0 0 0 369.408 369.664V1024h93.184v-95.744A418.56 418.56 0 0 0 928 558.592h96v-92.928zM512 837.888A325.888 325.888 0 1 1 837.888 512 325.888 325.888 0 0 1 512 837.888zm0 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol